import React, { useState } from 'react';
import './Setting.css';
import axios from 'axios';
import { COMPANY_URLS } from '../../../Utils/Company_App_Urls';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ResetNotification() {
    const [notificatonSetting, setNotificationSetting] = useState({
        securityAlert: false,
        applicationUpdates: false,
        emailNotification: false,
        jobPost: false,
    });
    const [isSaving, setIsSaving] = useState(false);

    const handleChangeNotification = (type) => {
        setNotificationSetting((prev) => ({
            ...prev,
            [type]: !prev[type],
        }));
    };

    const notificationOption = [
        {
            option: 'securityAlert',
            label: 'Security Alert',
            description: 'Be alerted of any unusual activity on your account.',
        },
        {
            option: 'applicationUpdates',
            label: 'Application Updates',
            description: 'Stay informed about new applicants that match your preferences.',
        },
        {
            option: 'emailNotification',
            label: 'Email Notification',
            description: 'Get Every Notification Through Email',
        },
        {
            option: 'jobPost',
            label: 'Job Post',
            description: 'Receive updates on the status of your job post, from submission to offer.',
        },
    ];

    const handleSaveChanges = async () => {
        setIsSaving(true);
        try {
            await axios.patch(
                COMPANY_URLS.changeNotificationSetting,
                notificatonSetting,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json',
                        'accept': 'application/json'
                    }
                }
            );
            toast.success("Notification settings saved successfully!");
        } catch (error) {
            console.error("Error saving settings:", error);
            toast.error("Failed to save notification settings");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="notification_main">
            <div className="reset-pass-title mb-4">
                <h1>Change Notification Setting</h1>
                <p>Customize How You Stay Informed and Connected</p>
            </div>
            {notificationOption.map((data, idx) => (
                <div className="toggle_group row d-flex justify-content-between mb-3"
                    key={idx}
                >
                    <div className="notification-items col-8 flex-grow-1">
                        <p>{data.label}</p>
                        <p>{data.description}</p>
                    </div>
                    <label className="switch col-3">
                        <input
                            type="checkbox"
                            checked={notificatonSetting[data.option]}
                            onChange={() => handleChangeNotification(data.option)}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            ))}
            <div className='btn_group_reset d-flex gap-5 justify-content-between align-items-center mt-5 flex-wrap border-0 p-0'>
                <button>Cancel</button>
                <button 
                    type='button' 
                    onClick={handleSaveChanges}
                    disabled={isSaving}
                >
                    {isSaving ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </div>
    );
}